export enum CemeteryPurchaseStatus {
	Purchased = 'purchased',
	NotPurchased = 'notPurchased',
	NotInterested = 'notInterested',
}
